import { m } from 'framer-motion';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Badge, { badgeClasses } from '@mui/material/Badge';

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { paths } from 'src/routes/paths';
import { varHover } from 'src/components/animate';
import { useSettingsContext } from 'src/components/settings';
import { useRouter } from 'src/routes/hooks';

// ----------------------------------------------------------------------

export default function SettingsButton({ sx }) {
  const settings = useSettingsContext();
  const router = useRouter();
  const handleClickItem = () => {
    router.push(paths.dashboard.settings.root);
  };

  return (
    <Badge
      color="error"
      variant="dot"
      invisible={true}
      sx={{
        [`& .${badgeClasses.badge}`]: {
          top: 8,
          right: 8,
        },
        ...sx,
      }}
    >
      <Box
        component={m.div}
        animate={{
          rotate: [0, settings.open ? 0 : 360],
        }}
        transition={{
          duration: 12,
          ease: 'linear',
          repeat: Infinity,
        }}
      >
        <IconButton
          component={m.button}
          whileTap="tap"
          whileHover="hover"
          variants={varHover(1.05)}
          aria-label="settings"
          //onClick={settings.onToggle}
          onClick={() => handleClickItem()}
          sx={{
            width: 40,
            height: 40,
          }}
        >
          <SettingsOutlinedIcon />
          {/* <Iconify icon="solar:settings-bold-duotone" width={24} /> */}
        </IconButton>
      </Box>
    </Badge>
  );
}

SettingsButton.propTypes = {
  sx: PropTypes.object,
};
